import { useAppSelector, useTranslation } from "@next-platform/client-common-core";

import { Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";
import useAuth from "@/services/useAuth";

const QueuePosition = () => {
  const { t } = useTranslation();
  const { status, position, time_left } = useAppSelector((state) => state?.waitingQueue) || {};
  const { isAuthenticated } = useAuth();
  if (status === "expired") return null;

  const minutes = Math.floor(Number(time_left) / 60);

  return (
    <>
      {position > 0 && status === "waiting" && isAuthenticated ? (
        <Text type={"warning"} variant={"sm"}>
          {time_left >= 60 ? (
            <Trans i18nKey="chat:page.waitingStatus.time" values={{ timeLeft: t("chat:page.waitingStatus.time.minutes", { count: minutes }) }} />
          ) : (
            <Trans i18nKey="chat:page.waitingStatus.position" values={{ position }} />
          )}
        </Text>
      ) : null}
      {status === "access" && isAuthenticated ? (
        <Text type={"success"}>
          <Trans i18nKey="chat:page.waitingStatus.chatAvailable" />
        </Text>
      ) : null}
    </>
  );
};

export default QueuePosition;
